<!-- Header -->

<div class="card-header card-header-grid">
  <!-- Search -->
  <div *ngIf="showSearchField" class="input-group input-lined" role="search">
    <div class="input-group-text">
      <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
    </div>
    <input
      class="form-control"
      type="search"
      placeholder="{{ 'general.search' | translate }}"
      attr.aria-label="{{ 'general.search' | translate }}"
      [(ngModel)]="filterTerm"
      (ngModelChange)="onSearch($event)"
    />
  </div>
  <!-- End Search -->

  <div
    class="spinner-border"
    role="status"
    attr.aria-label="{{ 'general.loading' | translate }}"
    *ngIf="isLoading"
  >
  </div>

  <div class="d-flex justify-content-end align-items-center">
    <div class="d-flex">
      <total-table-counter
        *ngIf="showTotal"
        [page]="activePage"
        [limit]="limitPage"
        [total]="total"
      ></total-table-counter>
    </div>

    <div
      class="btn-group ms-3"
      dropdown
      *ngIf="bulkActions?.length"
      [canSee]="[accessRights.SerieProposal_delete]"
    >
      <button
        class="btn btn-sm btn-white dropdown-toggle"
        type="button"
        dropdownToggle
        aria-controls="bulkAction"
      >
        {{ 'general.bulkActions' | translate }}
      </button>

      <ul
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        id="bulkAction"
      >
        <li *ngFor="let bulkAction of bulkActions">
          <a
            class="dropdown-item"
            href="javascript:;"
            (click)="onClickBulkAction(bulkAction)"
          >
            {{ 'serieProposalModule.' + bulkAction | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
<!-- End Header -->

<!-- Table -->
<div class="table-responsive">
  <table
    class="table table-borderless table-striped table-hover table-nowrap"
    [mfData]="tableData | recursiveFilter: filterTerm"
    #dataTable="mfDataTable"
    [mfRowsOnPage]="limitPage"
  >
    <thead class="table-light">
      <tr>
        <th
          scope="col"
          *ngIf="bulkActions?.length"
          (click)="onToggleAllChecked()"
          style="max-width: 60px"
        >
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="allCheckedToggle"
            attr.aria-label="{{ 'general.selectAll' | translate }}"
          />
        </th>

        <th scope="col" style="width: 20%">
          <mfDefaultSorter
            by="startDate"
            (click)="onSortfieldClick('startDate')"
          >
            {{ 'general.date' | translate }}
            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down': sortingField == 'startDate_asc',
                'fa-sort-up ': sortingField == 'startDate_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'startDate_asc' &&
                  sortingField !== 'startDate_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>

        <th scope="col" style="width: 25%">
          <mfDefaultSorter
            by="linkedProductId"
            (click)="onSortfieldClick('linkedProductId')"
          >
            {{ 'productModule.activity' | translate }}
            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down': sortingField == 'linkedProductId_asc',
                'fa-sort-up ': sortingField == 'linkedProductId_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'linkedProductId_asc' &&
                  sortingField !== 'linkedProductId_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>

        <th scope="col" style="width: 35%">
          <mfDefaultSorter
            by="productId"
            (click)="onSortfieldClick('productId')"
          >
            {{ 'productModule.resource' | translate }}
            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down': sortingField == 'productId_asc',
                'fa-sort-up ': sortingField == 'productId_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'productId_asc' &&
                  sortingField !== 'productId_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>

        <th scope="col" style="width: 20%">
          <mfDefaultSorter by="status" (click)="onSortfieldClick('status')">
            {{ 'general.status' | translate }}

            <i
              class="fa ms-1"
              role="img"
              [ngClass]="{
                'fa-sort-down ': sortingField == 'status_asc',
                'fa-sort-up ': sortingField == 'status_desc',
                'fa-sort text-muted  opacity-50':
                  sortingField !== 'status_asc' &&
                  sortingField !== 'status_desc'
              }"
              attr.aria-label="{{ 'wcag.sort' | translate }}"
            >
            </i>
          </mfDefaultSorter>
        </th>
        <th scope="col"
          ><span class="aria-hidden">{{
            'general.actions' | translate
          }}</span></th
        >
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of dataTable.data; let i = index"
        class="cursor-pointer"
      >
        <td *ngIf="bulkActions?.length" (click)="onCheckRow(item)">
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="this.checkedIds.get(item.id)"
            attr.aria-label="{{ 'wcag.selectThis' | translate }}"
          />
        </td>

        <td
          (click)="onRowClicked(item)"
          (keyup.enter)="onRowClicked(item)"
          tabindex="0"
          role="link"
        >
          {{
            item.startDate
              | date: 'EE dd MMM yyyy' : null : (selectedLanguage$ | async)
          }}

          {{ item.startDate | date: 'HH:mm' }} -
          {{ roundedMinute(item.endDate) | date: 'HH:mm' }}
        </td>
        <td (click)="onRowClicked(item)">
          {{ item.linkedProductId }}
          {{ (productEntities$ | async)[item.linkedProductId]?.description }}
        </td>
        <td (click)="onRowClicked(item)">
          {{ (productEntities$ | async)[item.productId]?.description }}
        </td>

        <td (click)="onRowClicked(item)">
          <span
            class="badge bg-soft-primary"
            *ngIf="item.status == serieProposalItemStatus.REQUESTED"
          >
            {{ 'serieProposalModule.requested' | translate }}
          </span>
          <span
            class="badge bg-soft-success"
            *ngIf="item.status == serieProposalItemStatus.ACCEPTED"
          >
            {{ 'serieProposalModule.accepted' | translate }}
          </span>
          <span
            class="badge bg-soft-warning"
            *ngIf="item.status == serieProposalItemStatus.COUNTER_PROPOSAL"
          >
            {{ 'serieProposalModule.counterProposal' | translate }}
          </span>
          <span
            class="badge bg-soft-danger"
            *ngIf="item.status == serieProposalItemStatus.DECLINED"
          >
            {{ 'serieProposalModule.declined' | translate }}
          </span>
        </td>
        <td>
          <i
            *ngIf="
              hasConflictingBooking(item) &&
              item.status != serieProposalItemStatus.ACCEPTED
            "
            role="img"
            class="fa fa-circle"
            aria-hidden="true"
          ></i>
          <button
            *ngIf="
              item.status != serieProposalItemStatus.ACCEPTED && showEditButton
            "
            class="btn btn-soft-primary btn-sm"
            type="button"
            aria-label="editSerieProposal"
            (click)="onClickMakeCounterProposal(item)"
          >
            {{ 'serieProposalModule.makeCounterProposal' | translate }}
          </button>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="14" class="pb-0">
          <table-footer
            class=""
            #footer
            [activePage]="activePage - 1"
            [limitOnPage]="limitPage"
            [totalPages]="pageCount"
            (selectedPage)="selectPage($event)"
            (searchLimit)="setSearchLimit($event)"
          >
          </table-footer>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
